'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { SHOP_HOME_PATH } from '@/features/shop/data/shop-routes';
import LoginPopUp from '@/common/components/appbar/loginPopUp/loginPopUp.component';
import Button from '@/common/components/button';
import CartWidgetV2 from '@/common/components/cart-widget-v2';
import { AppbarSearch } from '@/common/components/homeSearch/appbar-search.component';
import SettingDropDown from '@/common/components/setting/settingDropDown.component';
import { FeatureFlag } from '@/common/constants/feature-flag.enum';
import { useFeatureFlag } from '@/common/hooks/use-feature-flag.hook';
import { useSession } from '@/common/hooks/use-session.hook';
import HeaderLogoOrange from '~/public/assets/images/svg/header-logo-orange.svg';

function HeaderV2() {
  const [openLogin, setOpenLogin] = useState(false);
  const { status } = useSession();
  const showWitroBetaBadge = useFeatureFlag(FeatureFlag.ShopperWitroBetaBadge);

  return (
    <header className="w-full bg-white">
      <div className="flex h-16 w-full max-w-[1200px] items-center px-4 md:mx-auto md:h-20 md:px-0">
        <div className="flex w-full items-center justify-between gap-2 md:gap-5">
          <div className="flex min-w-0 w-full items-center gap-3 md:gap-[43px]">
            <Link
              href={SHOP_HOME_PATH}
              aria-label="صفحه اصلی فروشگاه ویترو"
              className="block h-full w-[60px] max-h-[18px] shrink-0 md:w-[120px] md:max-h-[36px]"
            >
              <HeaderLogoOrange />
            </Link>
            <AppbarSearch />
            {showWitroBetaBadge && (
              <span className="motion-safe:animate-pulse inline-flex shrink-0 h-6 items-center gap-1 whitespace-nowrap rounded-full border border-orange-300 bg-orange-50 px-2 text-[10px] font-semibold text-orange-800 md:h-7 md:px-2.5 md:text-xs">
                <span
                  aria-hidden="true"
                  className="size-1.5 rounded-full bg-orange-500"
                />
                نسخه آزمایشی
              </span>
            )}
          </div>
          <div className="hidden shrink-0 items-center gap-2 lg:flex">
            {status === 'unauthenticated' ? (
              <Button
                type="black"
                className="!h-9 whitespace-nowrap !px-3 !text-[11px] md:!h-11 md:!px-4 md:!text-xs"
                onClick={() => {
                  setOpenLogin(true);
                }}
              >
                ورود | ثبت نام
              </Button>
            ) : (
              <SettingDropDown iconOnly status={status} />
            )}
            <CartWidgetV2 id="store-click-cart-v1" />
          </div>
        </div>
      </div>
      <LoginPopUp
        isOpen={openLogin}
        onCancel={() => {
          setOpenLogin(false);
        }}
      />
    </header>
  );
}

export default HeaderV2;
